// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__21kfj","Table__action":"Table_Table__action__H3UvR","Table__cellEditMode":"Table_Table__cellEditMode__1zvB4"};